// Arabisch (ar), householdsApp: zelfde vorm als householdsApp.nl.ts (golf 6b). Wat ontbreekt valt
// terug op het Nederlands (nooit een rauwe sleutel op het scherm).
export const appHouseholdsAr = {
    question: 'من يسكن في البيت؟',
    questionBody: 'عندها نجهّز ما يناسبكم. يمكنك تغيير كل شيء لاحقًا، ولن يضيع شيء أبدًا.',
    types: {
        family: {
            name: 'عائلة مع أطفال',
            body: 'والدان مع أطفال. تقويم ومهام بالنجوم وتوصيل واستلام.',
        },
        two_home: {
            name: 'عائلة ببيتين',
            body: 'يعيش الأطفال جزئيًا أيضًا عند الوالد الآخر. هادئ ومحايد.',
        },
        couple: {
            name: 'زوجان',
            body: 'شخصان بالغان. تقويم مشترك وتسوّق وما يجب فعله.',
        },
        solo: {
            name: 'بمفردي',
            body: 'تحكّم في العمل والرياضة والمواعيد. قصير وواضح.',
        },
        student: {
            name: 'سكن طلابي',
            body: 'جدول تنظيف عادل وتسوّق ولوحة رسائل. اللوحة في الممر تعرف على من الدور في غسل الصحون.',
        },
        shared: {
            name: 'شركاء السكن',
            body: 'بيت مشترك بين بالغين. جدول عادل ولوحة في الممر.',
        },
        cohousing: {
            name: 'سكن جماعي أو فناء مشترك',
            body: 'مساكن مستقلة مع مساحة مشتركة. تقويم للقاعة المشتركة ورسائل ومن ينظّف.',
        },
        senior: {
            name: 'كبار السن في البيت',
            body: 'يعيشون باستقلال. خط كبير ومواعيد وتذكيرات (والأدوية أيضًا) والطقس.',
        },
        care: {
            name: 'كبار السن في البيت، والعائلة تتابع',
            body: 'شخص يعيش وحده، وعائلته تتابع عن بُعد. خط كبير وأزرار قليلة.',
        },
    },
    short: {
        family: 'عائلة',
        two_home: 'عائلة ببيتين',
        couple: 'زوجان',
        solo: 'بمفردي',
        student: 'سكن طلابي',
        shared: 'شركاء السكن',
        cohousing: 'سكن جماعي',
        senior: 'كبار السن في البيت',
        care: 'كبار السن مع العائلة',
    },
    /** Vervolgvraag bij Ouderen thuis (live r1): ja = care (familie kijkt mee), nee = senior. */
    seniorFamilyQuestion: 'هل تتابع العائلة عن بُعد؟',
    yes: 'نعم',
    no: 'لا',
    laterNote: 'عدة أجيال تحت سقف واحد؟ اختر عائلة مع أطفال.',
    modulesOn: 'سنشغّل هذه لكم',
    modulesOnHint: 'هل هذا صحيح؟ يمكنك تشغيل أي جزء أو إيقافه لاحقًا من الإعدادات.',
    confirm: 'صحيح، التالي',
    settingsTitle: 'نوع الأسرة',
    settingsBody: 'عائلة، شركاء سكن، وحدي …',
    settingsIntro: 'يحدد النوع الأجزاء المفعّلة افتراضيًا وشكل التطبيق وبعض الكلمات. لا يُحذف أي شيء أبدًا.',
    current: 'المختار الآن',
    choose: 'اختر نوعًا آخر',
    previewTitle: 'ما الذي يتغير؟',
    turnsOn: 'يُشغَّل',
    turnsOff: 'يُوقَف',
    turnsOffNote: 'ما بداخله يبقى محفوظًا. إذا شغّلته لاحقًا فكل شيء ما زال موجودًا.',
    kept: 'يبقى كما اخترتموه',
    nothingChanges: 'تبقى الأجزاء كما هي. يتغير الشكل وبعض الكلمات فقط.',
    lookChanges: 'ويتكيّف الشكل أيضًا.',
    resetChoices: 'أعد أيضًا اختياراتنا في الوحدات إلى الوضع الافتراضي',
    apply: 'التبديل إلى {name}',
    cancel: 'لا تبدّل',
    toast: 'أسرتكم الآن: {name}. لم يُحذف شيء.',
    onlyParents: 'يمكن للمسؤول فقط تغيير هذا.',
    words: {
        family: {
            members: 'أفراد العائلة',
            profileTitle: 'ما الذي يناسب عائلتكم؟',
            weatherBody: 'معطف أو حذاء مطر أو واقي شمس: نخبركم عندما يخرج الأطفال من البيت.',
            adult: 'أحد الوالدين',
            tasks: 'المهام',
            cleaning: 'التنظيف',
            household: 'العائلة',
            admin: 'أحد الوالدين',
        },
        adults: {
            members: 'من يسكن هنا',
            profileTitle: 'ما الذي يناسبكم؟',
            weatherBody: 'معطف أو مظلة أو واقي شمس: نخبرك قبيل خروجك من البيت.',
            adult: 'بالغ',
            tasks: 'المهام',
            cleaning: 'التنظيف',
            household: 'الأسرة',
            admin: 'المسؤول',
        },
        shared: {
            members: 'شركاء السكن',
            profileTitle: 'ما الذي يناسب بيتكم؟',
            weatherBody: 'معطف أو مظلة أو واقي شمس: على لوحة الممر، قبيل خروجك من البيت.',
            adult: 'شريك السكن',
            tasks: 'المهام',
            cleaning: 'التنظيف',
            household: 'البيت',
            admin: 'المسؤول',
        },
        care: {
            members: 'العائلة',
            profileTitle: 'ما الذي يناسبكم؟',
            weatherBody: 'معطف أو مظلة أو واقي شمس: نخبرك قبيل خروجك من البيت.',
            adult: 'بالغ',
            tasks: 'المهام',
            cleaning: 'التنظيف',
            household: 'الأسرة',
            admin: 'مقدّم الرعاية',
        },
    },
    greetingHouse: 'سعداء برؤيتك',
    wizardRotationTitle: 'جدول عادل',
    wizardRotationBody: 'المطبخ والحمام والممر والقمامة والجلي تدور كل أسبوع، ويطبخ شخص مختلف كل مساء. تُظهر لوحة الممر على من الدور.',
    wizardAdultsTitle: 'جاهز للبدء',
    wizardAdultsBody: 'ضع مواعيدك في الأجندة وتابع ما يجب فعله. سينبّهك هاتفك عندما يفيد ذلك.',
    wizardMembersShared: 'من يسكن في البيت؟ يمكنك لاحقًا منح كل شخص دخوله الخاص.',
    /** Golf 6b fixer r1: woorden bij "alleen" (enkelvoud; de rest van de volwassen set blijft). */
    soloWords: {
        members: 'من ينتمي',
        profileTitle: 'ما الذي يناسبك؟',
        profileBody: 'اختر المطبخ والدين والطعام، فترى غالبًا ما يناسبك. هذا ليس ضروريًا.',
    },
    /** Live r1: woorden bij een woongroep of hofje (bovenop de volwassen set). */
    cohousingWords: {
        members: 'السكان',
        profileTitle: 'ما الذي يناسب مجموعتكم السكنية؟',
        household: 'المجموعة السكنية',
        adult: 'ساكن',
    },
    /** Golf 6b fixer r1: toon per soort (geen kindertaal bij volwassen soorten; gezin = standaard). */
    tone: {
        adults: {
            membersTitle: 'من يسكن هنا',
            membersIntro: 'كل من يظهر على اللوحة. ترى لون كل شخص في كل مكان.',
            membersAdd: 'شخص',
            membersAddLong: 'إضافة شخص',
            membersNew: 'شخص جديد',
            namePlaceholder: 'مثلًا نور',
            face: 'رمز',
            kidLockTitle: 'قفل الجهاز اللوحي',
            kidLockBody: 'رمز PIN قبل أن يؤشّر أحد على شيء في الجهاز اللوحي. مغلق افتراضيًا.',
            exportAll: 'الجميع',
            devicesIntro: 'الأجهزة اللوحية التي تعمل عليها لوحتكم.',
            library: 'أفكار للمهام',
            libraryIntro: 'اختر مهمة ولمن هي.',
            wizardMembersTitle: 'من يسكن هنا؟',
            wizardMembersBody: 'أعط كل شخص لونًا خاصًا. ستراه في كل مكان.',
            noTasksTitle: 'لا مهام اليوم',
            noTasksBody: 'كل شيء منجز.',
            tasksWidget: 'مهام اليوم',
            tasksAll: 'كل المهام',
            tasksEmptyBody: 'ابدأ بشيء صغير، مثل الغسيل أو سقي النباتات.',
            exportBody: 'نزّل التقويم كملف ‎.ics‎، للجميع أو لكل شخص.',
            dataBody: 'نسخة من بياناتكم كملف (JSON)، بما في ذلك الاختيارات في {profile}. تؤكد أولًا بكلمة المرور.',
            dataAll: 'الكل',
            privacyEntryBody: 'نزّل كل شيء، أو أزل شخصًا، أو احذف اللوحة.',
            approvalHint: 'يراجع شخص آخر المهمة قبل أن تُحسب منجزة.',
            supportIntro: 'تحتاج مساعدة؟ يمكن لـ AMUMIN أن يطّلع معكم لفترة، للقراءة فقط. أنت تحدد المدة، ويمكن لأي مسؤول إيقاف ذلك فورًا في أي وقت.',
            supportOff: 'متوقف. لا أحد في AMUMIN يستطيع رؤية لوحتكم.',
            supportSees: 'ترى AMUMIN حينها: أسماء كل من على اللوحة، وعناوين مواعيد اليوم والأيام الستة التالية (قد يرد في العنوان شيء مثل طبيب الأسنان؛ المواعيد ذات رمز ديني مثل المسجد أو الكنيسة لا تظهر)، والغرف والأجهزة اللوحية. لا ترى: الدين أو الصحة أو المدرسة أو عناوين البريد الإلكتروني أو الصور. كل مرة اطلاع تظهر أدناه.',
        },
        solo: {
            membersTitle: 'من ينتمي',
            membersIntro: 'أنت، ومن تضيفه لاحقًا. ترى لونك في كل مكان.',
            membersAdd: 'شخص',
            membersAddLong: 'إضافة شخص',
            membersNew: 'شخص جديد',
            namePlaceholder: 'مثلًا نور',
            face: 'رمز',
            kidLockTitle: 'قفل الجهاز اللوحي',
            kidLockBody: 'رمز PIN قبل أن يؤشّر أحد على شيء في الجهاز اللوحي. مغلق افتراضيًا.',
            exportAll: 'كل شيء',
            devicesIntro: 'الأجهزة اللوحية التي تعمل عليها لوحتك.',
            library: 'أفكار للمهام',
            libraryIntro: 'اختر مهمة تقوم بها كثيرًا.',
            wizardMembersTitle: 'هل من أحد آخر؟',
            wizardMembersBody: 'أنت موجود على اللوحة بالفعل. هل هناك شخص آخر، مثلًا للمواعيد المشتركة؟ أضفه هنا أو لاحقًا.',
            noTasksTitle: 'لا مهام اليوم',
            noTasksBody: 'كل شيء منجز.',
            tasksWidget: 'مهام اليوم',
            tasksAll: 'كل المهام',
            tasksEmptyBody: 'ابدأ بشيء صغير، مثل الغسيل أو سقي النباتات.',
            exportBody: 'نزّل التقويم كملف ‎.ics‎، للجميع أو لكل شخص.',
            dataBody: 'نسخة من بياناتكم كملف (JSON)، بما في ذلك الاختيارات في {profile}. تؤكد أولًا بكلمة المرور.',
            dataAll: 'الكل',
            privacyEntryBody: 'نزّل كل شيء، أو أزل شخصًا، أو احذف اللوحة.',
            approvalHint: 'تراجع المهمة بنفسك قبل أن تُحسب منجزة.',
            supportIntro: 'تحتاج مساعدة؟ يمكن لـ AMUMIN أن يطّلع معك لفترة، للقراءة فقط. أنت تحدد المدة، ويمكنك إيقاف ذلك فورًا في أي وقت.',
            supportOff: 'متوقف. لا أحد في AMUMIN يستطيع رؤية لوحتك.',
            supportSees: 'ترى AMUMIN حينها: أسماء كل من على اللوحة، وعناوين مواعيد اليوم والأيام الستة التالية (قد يرد في العنوان شيء مثل طبيب الأسنان؛ المواعيد ذات رمز ديني مثل المسجد أو الكنيسة لا تظهر)، والغرف والأجهزة اللوحية. لا ترى: الدين أو الصحة أو المدرسة أو عناوين البريد الإلكتروني أو الصور. كل مرة اطلاع تظهر أدناه.',
        },
        shared: {
            membersTitle: 'شركاء السكن',
            membersIntro: 'كل من يسكن في البيت. ترى لون كل شخص في كل مكان.',
            membersAdd: 'شريك سكن',
            membersAddLong: 'إضافة شريك سكن',
            membersNew: 'شريك سكن جديد',
            namePlaceholder: 'مثلًا سانه',
            face: 'رمز',
            kidLockTitle: 'قفل الجهاز اللوحي',
            kidLockBody: 'رمز PIN قبل أن يؤشّر أحد على شيء في الجهاز اللوحي في الممر. مغلق افتراضيًا.',
            exportAll: 'البيت كله',
            devicesIntro: 'الأجهزة اللوحية التي تعمل عليها لوحة البيت.',
            library: 'أفكار للمهام',
            libraryIntro: 'اختر مهمة ومن يقوم بها.',
            wizardMembersTitle: 'من يسكن هنا؟',
            wizardMembersBody: 'من يسكن في البيت؟ يمكنك لاحقًا منح كل شخص دخوله الخاص.',
            noTasksTitle: 'لا مهام اليوم',
            noTasksBody: 'انظر في جدول المناوبة لتعرف من يفعل ماذا.',
            tasksWidget: 'مهام اليوم',
            tasksAll: 'كل المهام',
            tasksEmptyBody: 'ابدأ بشيء صغير، مثل إخراج القمامة.',
            exportBody: 'نزّل التقويم كملف ‎.ics‎، للجميع أو لكل شخص.',
            dataBody: 'نسخة من بياناتكم كملف (JSON)، بما في ذلك الاختيارات في {profile}. تؤكد أولًا بكلمة المرور.',
            dataAll: 'البيت كله',
            privacyEntryBody: 'نزّل كل شيء، أو أزل شخصًا، أو احذف اللوحة.',
            approvalHint: 'يراجع أحد شركاء السكن المهمة قبل أن تُحسب منجزة.',
            supportIntro: 'تحتاج مساعدة؟ يمكن لـ AMUMIN أن يطّلع معكم لفترة، للقراءة فقط. أنت تحدد المدة، ويمكن لأي مسؤول في البيت إيقاف ذلك فورًا في أي وقت.',
            supportOff: 'متوقف. لا أحد في AMUMIN يستطيع رؤية لوحة بيتكم.',
            supportSees: 'ترى AMUMIN حينها: أسماء كل من على اللوحة، وعناوين مواعيد اليوم والأيام الستة التالية (قد يرد في العنوان شيء مثل طبيب الأسنان؛ المواعيد ذات رمز ديني مثل المسجد أو الكنيسة لا تظهر)، والغرف والأجهزة اللوحية. لا ترى: الدين أو الصحة أو المدرسة أو عناوين البريد الإلكتروني أو الصور. كل مرة اطلاع تظهر أدناه.',
        },
        care: {
            membersTitle: 'العائلة',
            membersIntro: 'كل من يساعد أو يظهر على اللوحة. ترى لون كل شخص في كل مكان.',
            membersAdd: 'شخص',
            membersAddLong: 'إضافة شخص',
            membersNew: 'شخص جديد',
            namePlaceholder: 'مثلًا أنيا',
            face: 'رمز',
            kidLockTitle: 'قفل الجهاز اللوحي',
            kidLockBody: 'رمز PIN قبل أن يؤشّر أحد على شيء في الجهاز اللوحي. مغلق افتراضيًا.',
            exportAll: 'الجميع',
            devicesIntro: 'الأجهزة اللوحية التي تعمل عليها اللوحة.',
            library: 'أفكار للمهام',
            libraryIntro: 'اختر مهمة ولمن هي.',
            wizardMembersTitle: 'من يساعد؟',
            wizardMembersBody: 'أضف كل من يساعد أو يجب أن يظهر على اللوحة. لكل شخص لون خاص.',
            noTasksTitle: 'لا مهام اليوم',
            noTasksBody: 'كل شيء منجز.',
            tasksWidget: 'مهام اليوم',
            tasksAll: 'كل المهام',
            tasksEmptyBody: 'ابدأ بشيء صغير، مثل الأدوية أو التسوق.',
            exportBody: 'نزّل التقويم كملف ‎.ics‎، للجميع أو لكل شخص.',
            dataBody: 'نسخة من بياناتكم كملف (JSON)، بما في ذلك الاختيارات في {profile}. تؤكد أولًا بكلمة المرور.',
            dataAll: 'الكل',
            privacyEntryBody: 'نزّل كل شيء، أو أزل شخصًا، أو احذف اللوحة.',
            approvalHint: 'يراجع أحد المسؤولين المهمة قبل أن تُحسب منجزة.',
            supportIntro: 'تحتاج مساعدة؟ يمكن لـ AMUMIN أن يطّلع معكم لفترة، للقراءة فقط. أنت تحدد المدة، ويمكن لأي مسؤول إيقاف ذلك فورًا في أي وقت.',
            supportOff: 'متوقف. لا أحد في AMUMIN يستطيع رؤية لوحتكم.',
            supportSees: 'ترى AMUMIN حينها: أسماء كل من على اللوحة، وعناوين مواعيد اليوم والأيام الستة التالية (قد يرد في العنوان شيء مثل طبيب الأسنان؛ المواعيد ذات رمز ديني مثل المسجد أو الكنيسة لا تظهر)، والغرف والأجهزة اللوحية. لا ترى: الدين أو الصحة أو المدرسة أو عناوين البريد الإلكتروني أو الصور. كل مرة اطلاع تظهر أدناه.',
        },
    },
    rotation: {
        title: 'جدول المناوبة',
        intro: 'تدور المهام بعدل: من جاء دوره ينتقل إلى آخر الصف. ومن كان غائبًا يتخطى دورًا ثم يعود أول الصف.',
        thisWeek: 'هذا الأسبوع',
        today: 'اليوم',
        nextUp: 'بعد ذلك',
        weekOf: 'أسبوع {date}',
        nobody: 'لا أحد مشارك',
        done: 'أنجزها {name}',
        notYet: 'لم تُنجز بعد',
        swapped: 'تم التبديل',
        skipped: '{name} غائب',
        swap: 'تبديل',
        swapTitle: 'من يقوم بـ{duty} {period}؟',
        swapPeriodWeek: 'هذا الأسبوع',
        swapPeriodDay: 'اليوم',
        swapUndo: 'التراجع عن التبديل',
        swapSaved: '{name} يقوم بـ{duty}',
        swapRemoved: 'تم التراجع عن التبديل',
        away: 'غائب',
        awayTitle: 'شخص غائب لفترة',
        awayBody: 'في عطلة أو مسافر للعمل؟ يتخطى دورًا ثم يعود أول الصف.',
        awayWho: 'من',
        awayFrom: 'من',
        awayTo: 'حتى (ضمنًا)',
        awayAdd: 'تسجيل الغياب',
        awayRemove: 'عاد إلى البيت',
        awayItem: '{name}: من {from} حتى {to}',
        awaySaved: 'تم تسجيل غياب {name}',
        awayRemoved: '{name} عاد إلى البيت',
        awayInvalid: 'تاريخ النهاية قبل تاريخ البداية.',
        empty: 'لا يوجد جدول مناوبة بعد',
        emptyBody: 'أنشئ جدولًا بالمطبخ والحمام والممر والقمامة والجلي والطبخ. بعدها يمكنك حذف مهام أو إضافتها في التنظيف.',
        setup: 'إنشاء جدول المناوبة',
        setupDone: 'في الجدول {count} مهام',
        setupNothing: 'هذه المهام موجودة في الجدول بالفعل',
        weekly: 'كل أسبوع',
        daily: 'كل يوم',
        others: 'مهام أخرى',
        othersBody: 'مهام من التنظيف لا تدور بعد.',
        makeWeekly: 'تدوير كل أسبوع',
        makeDaily: 'تدوير كل يوم',
        stopRotating: 'إيقاف التدوير',
        rotatingOn: '{duty} تدور الآن',
        rotatingOff: '{duty} لم تعد تدور',
        onBoard: 'تُظهر لوحة الممر على من الدور هذا الأسبوع. ويمكن التأشير هناك بلمسة.',
        duties: {
            kitchen: 'المطبخ',
            bathroom: 'الحمام',
            hallway: 'الممر والدرج',
            trash: 'القمامة',
            dishes: 'الجلي',
            cooking: 'الطبخ',
        },
    },
};
//# sourceMappingURL=householdsApp.ar.js.map